export default function ProjsSAPLanding(){
  return(
    <div>
      SAP Landing Page coming soon! 
    </div>
  );
}